import React, { useState, useEffect } from "react";
import { Box, Button, Stack, Typography } from "@mui/material";
import {
  DataGrid,
  GridToolbarExport,
  GridToolbarFilterButton,
  GridToolbarContainer,
  GridToolbarDensitySelector,
  GridToolbarColumnsButton,
} from "@mui/x-data-grid";
import axiosInstance from "../../utils/api/api";
import CreateAdmin from "./_components/CreateAdmin";
import CustomNoRowsOverlay from "../../components/NoRows";
import DetailAdmin from "./Detail/DetailAdmin";

function CustomToolbar() {
  return (
    <GridToolbarContainer>
      <GridToolbarColumnsButton />
      <GridToolbarFilterButton />
      <GridToolbarDensitySelector />
      <GridToolbarExport printOptions={{ disableToolbarButton: true }} />
    </GridToolbarContainer>
  );
}

const columns = [
  {
    field: "full_name",
    headerClassName: "header",
    headerName: "Name",
    width: 600,
    flex: 1,
    renderCell: ({ value }) => (
      <Typography noWrap fontSize={14}>
        {value}
      </Typography>
    ),
  },
  {
    field: "email",
    headerClassName: "header",
    headerName: "Email",
    width: 100,
    flex: 1,
    renderCell: ({ value }) => (
      <Typography noWrap fontSize={14}>
        {value}
      </Typography>
    ),
  },
  {
    field: "phone_number",
    headerClassName: "header",
    headerName: "Phone",
    width: 150,
    flex: 1,
    renderCell: ({ value }) => (
      <Typography noWrap fontSize={14}>
        {value}
      </Typography>
    ),
  },
  {
    field: "role",
    headerClassName: "header",
    headerName: "Role",
    width: 100,
    flex: 1,
    renderCell: (params) =>
      params.value === "Manager" ? (
        <button
          style={{
            color: "#CB3A31",
            fontFamily: "Murecho",
            fontWeight: "500",
            fontSize: "12px",
            border: "1px solid #EEB4B0",
            borderRadius: "6px",
            backgroundColor: "#FFF4F2",
          }}
        >
          <span>{params.value}</span>
        </button>
      ) : params.value === "Admin Product" ? (
        <button
          style={{
            color: "#20573D",
            fontFamily: "Murecho",
            fontWeight: "500",
            fontSize: "12px",
            border: "1px solid #B8DBCA",
            borderRadius: "6px",
            backgroundColor: "#F7F7F7",
          }}
        >
          <span>Production Admin</span>
        </button>
      ) : params.value === "SuperAdmin" ? (
        <button
          style={{
            color: "#222",
            fontFamily: "Murecho",
            fontWeight: "500",
            fontSize: "12px",
            border: "1px solid #222",
            borderRadius: "6px",
            backgroundColor: "#fff",
          }}
        >
          <span>{params.value}</span>
        </button>
      ) : params.value === "Admin Warehouse" ? (
        <button
          style={{
            color: "#3267E3",
            fontFamily: "Murecho",
            fontWeight: "500",
            fontSize: "12px",
            border: "1px solid #B1C5F6",
            borderRadius: "6px",
            backgroundColor: "#F0F3FF",
          }}
        >
          <span>Warehouse Admin</span>
        </button>
      ) : (
        <button
          style={{
            color: "#155C33",
            fontFamily: "Murecho",
            fontWeight: "500",
            fontSize: "12px",
            border: "none",
            borderRadius: "6px",
            backgroundColor: "#DEF8E9",
          }}
        >
          <span>{params.value}</span>
        </button>
      ),
  },
  {
    field: "status",
    headerClassName: "header",
    headerName: "Status",
    width: 100,
    flex: 1,
    renderCell: ({ value }) =>
      value ? (
        <button
          style={{
            color: "#21573D",
            fontFamily: "Murecho",
            fontWeight: "600",
            fontSize: "12px",
            border: "1px solid #B8DBCA",
            borderRadius: "5px",
            backgroundColor: "#F7F7F7",
          }}
        >
          Active
        </button>
      ) : (
        <button
          style={{
            color: "#444",
            fontFamily: "Murecho",
            fontWeight: "600",
            fontSize: "12px",
            border: "1px solid #444",
            borderRadius: "5px",
            backgroundColor: "#F7F7F7",
          }}
        >
          Non-active
        </button>
      ),
  },
  {
    field: "_id",
    headerClassName: "header",
    headerName: "Action",
    width: 100,
    flex: 1,
    renderCell: () => (
      <button
        style={{
          color: "#fff",
          // fontFamily: "Murecho",
          fontWeight: "600",
          fontSize: "12px",
          border: "1px solid #222",
          borderRadius: "4px",
          backgroundColor: "#222",
          padding: "5px",
          cursor: "pointer",
        }}
      >
        See Details
      </button>
    ),
  },
];

const AdminManagement = () => {
  const [pageSize, setPageSize] = useState(10);
  const [modalOpen, setModalOpen] = useState(false);
  const [openDetail, setOpenDetail] = useState(false);
  const [data, setData] = useState(null);
  const [admins, setAdmins] = useState([]);
  const token = JSON.parse(localStorage.getItem("userToken"));
  const authentication = {
    headers: { Authorization: `Bearer ${token}` },
  };

  const getAdmin = () => {
    axiosInstance
      .get("/api/admins", authentication)
      .then((res) => {
        // console.log(res);
        setAdmins(
          res.data.filter(
            (dt) => dt.role !== "SuperAdmin" && dt.role !== "Manager",
          ),
        );
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const onDetail = (item) => {
    setData(item);
    setOpenDetail(true);
  };

  useEffect(() => {
    getAdmin();
  }, []);

  return (
    <Box flex="1" sx={{ backgroundColor: "#f6f6f6" }}>
      <CreateAdmin
        open={modalOpen}
        setModalOpen={setModalOpen}
        getAdmin={getAdmin}
      />
      <DetailAdmin
        open={openDetail}
        setModalOpen={setOpenDetail}
        getAdmin={getAdmin}
        data={data}
      />
      <Stack
        direction="row"
        justifyContent="space-between"
        paddingX={3}
        sx={{ backgroundColor: "#F6F6F6" }}
        paddingY={2}
      >
        <Typography variant="h4" fontWeight="500">
          Admin Management
        </Typography>
        <Button
          sx={{
            textTransform: "capitalize",
            borderRadius: "11px",
            backgroundColor: "#222",
            color: "#FFF",
            ":hover": {
              backgroundColor: "#444",
              color: "#FFF",
            },
          }}
          variant="contained"
          onClick={() => setModalOpen(true)}
        >
          Create Admin
        </Button>
      </Stack>
      <Stack>
        <Box
          sx={{
            "& .header": {
              backgroundColor: "#FFF",
              color: "#000",
            },
            "& .header-font": {
              backgroundColor: "#F6F6F6",
              color: "#F6F6F6",
            },
            padding: 3,
          }}
        >
          <DataGrid
            rows={admins}
            columns={columns}
            pageSize={pageSize}
            autoHeight
            getRowId={(rows) => rows._id}
            header
            isRowSelectable={() => false}
            pagination
            onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
            rowsPerPageOptions={[10, 15, 25]}
            components={{
              Toolbar: CustomToolbar,
              NoRowsOverlay: CustomNoRowsOverlay,
            }}
            onRowClick={(rows) => onDetail(rows.row)}
            sx={{
              backgroundColor: "#fff",
              borderRadius: "10px",
              border: "none",
              color: "#535252",
            }}
          />
        </Box>
      </Stack>
    </Box>
  );
};

export default AdminManagement;
